import "./Product.css";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Container, Dropdown, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { notification } from "antd";
import { Breadcrumb } from "antd";
import IconsGen from "../../components/icons_generator/IconsGen";
import AxiosController from "../../components/authentication/AxiosController";
import Loader from "../../components/loader/Loader";
import ProductsSlider from "../../components/home/ProductsSlider";
import ProductSwipper from "../../components/home/ProductSwipper";
import easyOrders from "../../imgs/easy-icon.png";
import CreateProduct from "../../components/panel/outside integrations/requests classes/CreateProduct";
import { syncSingleProduct } from "../../components/panel/outside integrations/light funnels/LightFunnelsAPIKeys";
import VariantsSelector from "./VariantsSelector";
import { UserContext } from "../../components/contexts/UserContext";
import { Helmet } from "react-helmet";
import { LuBox, LuTag, LuTrendingUp, LuZap, LuShoppingCart, LuFileText } from "react-icons/lu";
import { toast } from "react-toastify";
import lightFunnels from "../../imgs/lightfunnels.svg";
import { notifyError, notifySuccess } from "../../components/toastify/toastify";
import OfferCountdownTimer from "../../components/reuseable/OfferCountdownTimer";
import { isProductOfferActive } from "../../components/reuseable/ProductPriceDisplay";
import {
  addProductDiscountToCart,
  addProductToCart,
  ensureSaSkuOrderable,
} from "../../components/cart/addToCartService";
import { fetchProductDetails } from "../../components/globals/functions/saExclusiveOrder";

const Product = () => {
  const { slug, lang, id } = useParams();
  const [_] = useTranslation("global");
  const currencyLabel =
    slug === "sa"
      ? _(`panel.sar`)
      : slug === "EG"
      ? _(`panel.egp`)
      : slug === "om"
      ? _(`panel.omr`)
      : _(`panel.aed`);
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const { userData } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const role = localStorage.getItem("role") ?? "";
  const [product, handleProduct] = useState({});
  const [api, contextHolder] = notification.useNotification();
  const [offersData, setOffersData] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [sameCatProducts, handleSameCatProducts] = useState([]);
  const [productImgs, handleProductImgs] = useState([]);
  const [resData, setResData] = useState([]);
  const [productVariants, handleProductVariants] = useState([]);
  const [selectedVariant, handleSelectedVariant] = useState("");
  const [hasKey2, setHasKey] = useState(false);
  const [key, setKey] = useState([]);
  const [yallaShopKey, setYallaShopKey] = useState([]);
  const [hasKeyForYallaShop, setHasKeyForYallaShop] = useState(false);
  const [lightFunnelsKey, setLightFunnelsKey] = useState([]);
  const [hasKeyForLightFunnels, setHasKeyForLightFunnels] = useState(false);
  const [shopifyIntegrations, setShopifyIntegrations] = useState([]);

  const [altName, handleAltName] = useState("");
  const token = localStorage.getItem("token") ?? "";
  const Navigate = useNavigate();

  const box_head_dir = lang === "en" ? "ltr" : "rtl";
  const exclusiveParam = urlParams.get("exclusive");

  const ensureProductOrderAllowed = async () =>
    ensureSaSkuOrderable({
      slug,
      lang,
      token,
      productId: id,
      variantId: selectedVariant?.id,
      sku: selectedVariant?.sku,
      exclusiveParam,
    });

  const exportToEasyOrders = async (secretKey) => {
    if (!(await ensureProductOrderAllowed())) return;
    setLoading(true);
    axios
      .create({
        headers: {
          Accept: "application/json",
        },
      })
      .post(
        `https://api.easy-orders.net/api/v1/external-apps/products`,
        new CreateProduct(resData, slug),
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Api-Key": secretKey,
          },
        }
      )
      .then((res) => {
        notifySuccess("تم إضافة المنتج لإيزي اوردرز");
        setLoading(false);
      })
      .catch((e) => {
        notifyError(e.response.data.message);
        setLoading(false);
      });
  };
  const exportToYallaShop = (secretKey) => {
    setLoading(true);
    axios
      .create({
        headers: {
          Accept: "application/json",
        },
      })
      .post(
        `https://api.yallashop.me/api/EcomboWebHook/async/SyncDSProduct`,
        new CreateProduct(resData, slug),
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Api-Key": secretKey,
          },
        }
      )
      .then((res) => {
        notifySuccess("تم إضافة المنتج لإيزي اوردرز");
        setLoading(false);
      })
      .catch(() => {
        notifyError("تعذر إضافة المنتج لإيزي اوردرز");
        setLoading(false);
      });
  };

  const exportToLightFunnels = async (secretKey) => {
    setLoading(true);
    try {
      await syncSingleProduct(token, lang, slug, secretKey, id);
      openNotification(
        lang == "ar" ? "topRight" : "topLeft",
        _("panel.productAddedToEasyOrders")
      );

      notifySuccess("تم إضافة المنتج للايت فانلز");
    } catch (error) {
      notifyError("تعذر إضافة المنتج للايت فانلز");
    } finally {
      setLoading(false);
    }
  };

  const hasKey = () => {
    AxiosController.get(`api/${slug}/${lang}/get-secrets/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        type: "easy_order",
      },
    })
      .then((res) => {
        if (res.data) setHasKey(true);
        setKey(res.data);
      })
      .catch(() => {});
  };

  const hasKeyYallaShop = () => {
    AxiosController.get(`api/${slug}/${lang}/get-secrets/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        type: "yalla_shop",
      },
    })
      .then((res) => {
        if (res.data) setHasKeyForYallaShop(true);
        setYallaShopKey(res.data);
      })
      .catch(() => {});
  };

  const hasKeyLightFunnels = () => {
    AxiosController.get(`api/${slug}/${lang}/get-secrets/`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        type: "lightfunnels",
      },
    })
      .then((res) => {
        if (res.data) setHasKeyForLightFunnels(true);
        setLightFunnelsKey(res.data);
      })
      .catch(() => {});
  };

  const fetchShopifyIntegrations = () => {
    AxiosController.get(`api/${slug}/${lang}/shopify/integrations`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        const active = (res.data.integrations || []).filter(
          (i) => i.status === "active"
        );
        setShopifyIntegrations(active);
      })
      .catch(() => {});
  };

  const exportToShopify = (integrationId) => {
    setLoading(true);
    AxiosController.post(
      `api/${slug}/${lang}/shopify/products/send`,
      {
        integration_id: integrationId,
        product_id: id,
        include_variants: true,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then(() => {
        notifySuccess(_("panel.shopifySendSuccess"));
        setLoading(false);
      })
      .catch((e) => {
        notifyError(
          e?.response?.data?.message || _("panel.shopifySendError")
        );
        setLoading(false);
      });
  };

  const applyProductData = (data) => {
    setResData(data);
    handleProduct(data.product);
    handleSameCatProducts(data.same_category);
    handleAltName(data.alt_name);
    handleProductImgs(data.product_imgs);
    if (data.product_variants?.length > 0) {
      handleProductVariants(data.product_variants);
      handleSelectedVariant(data.product_variants[0]);
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (!token) {
      Navigate(`/ar/auth/login`);
      return;
    }

    window.scrollTo(0, 0);
    setLoading(true);

    fetchProductDetails({
      slug,
      lang,
      token,
      productId: id,
      exclusiveParam,
    })
      .then(({ data, usedExclusive }) => {
        const hasVariants = applyProductData(data);

        if (!hasVariants) {
          if (exclusiveParam === "1" || usedExclusive) {
            notifyError("تعذر تحميل المنتج");
          } else {
            Navigate(`/${slug}/${lang}/`);
          }
          return;
        }

        if (usedExclusive && exclusiveParam !== "1") {
          Navigate(`/${slug}/${lang}/product/${id}?exclusive=1`, {
            replace: true,
          });
        }
      })
      .catch(() => {
        if (exclusiveParam === "1") {
          notifyError("تعذر تحميل المنتج الحصري");
        } else {
          Navigate(`/${slug}/${lang}/`);
        }
      })
      .finally(() => {
        setLoading(false);
      });

    hasKey();
    hasKeyYallaShop();
    hasKeyLightFunnels();
    fetchShopifyIntegrations();
  }, [id, slug, lang, exclusiveParam, token]);
  const openNotification = (placement, status) => {
    api.success({
      style: { direction: lang == "ar" ? "rtl" : "ltr" },
      description: `${status}!`,
      placement,
    });
  };

  const addToCart = () => {
    setLoading(true);

    addProductToCart({
      slug,
      lang,
      token,
      productId: id,
      variantId: selectedVariant.id,
      sku: selectedVariant.sku,
      exclusiveParam,
    })
      .then(() => {
        setLoading(false);
        document.getElementById("ecomboCart").click();
      })
      .catch((e) => {
        setLoading(false);
        if (e.message === "SKU not orderable") return;
        toast.error(e.response?.data?.error);
      });
  };
  const addToFav = () => {
    AxiosController.post(
      `api/${slug}/${lang}/add-to-fav/${id}`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((res) => {
        openNotification(
          lang == "ar" ? "topRight" : "topLeft",
          res.data.success.fav_added
        );
      })
      .catch((e) => {
        Navigate(`/${slug}/${lang}/product/${id}`);
      });
  };

  const get_product_discounts = () => {
    setLoading(true);
    AxiosController.get(
      `/apiv2/${slug}/${lang}/product-discounts/product/${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((res) => {
        setLoading(false);
        setOffersData(res?.data);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const addOfferToCart = () => {
    setLoading(true);
    addProductDiscountToCart({
      slug,
      lang,
      token,
      offerId: selectedOffer,
    })
      .then(() => {
        setLoading(false);
        document.getElementById("ecomboCart").click();
      })
      .catch((e) => {
        if (e.message === "SKU not orderable") {
          setLoading(false);
          return;
        }
        toast.error(e.response?.data?.error);
        setLoading(false);
      });
  };
  const handleOfferChange = (e) => {
    setSelectedOffer(e.target.id);
  };
  useEffect(() => {
    if (id) {
      get_product_discounts();
    }
  }, [id]);

  return (
    <Container dir={lang === "en" ? "rtl" : "ltr"}>
      {contextHolder}
      <div>
        <Helmet>
          <title>{product.title}</title>
          <meta name="description" content={product.description} />
        </Helmet>
      </div>
      <Breadcrumb
        style={{ direction: box_head_dir }}
        separator=">"
        className="p-4 px-0 fs-5"
        itemRender={(route, _, routes) => {
          const last = routes.indexOf(route) === routes.length - 1;
          return last ? (
            <Link style={{ color: "#eea536" }}>{route.title}</Link>
          ) : (
            <Link to={route.href} style={{ color: "#57c2c5" }}>
              {route.title}
            </Link>
          );
        }}
        items={[
          {
            title: _("panel.main"),
            href: `/${slug}/${lang}`,
          },
          {
            title: _("panel.products"),
            href: `/${slug}/${lang}/panel/products`,
          },
          {
            title:
              lang == "en"
                ? sameCatProducts[0]
                  ? sameCatProducts[0]["arabic_name"]
                  : ""
                : sameCatProducts[0]
                ? sameCatProducts[0]["arabic_name"]
                : "",
            href: `/${slug}/${lang}/category/${product.category_id}`,
          },
        ]}
      />

      <div
        className="product-whole-container d-flex flex-column"
        style={{ position: "relative" }}
      >
        <Loader active={loading} />
        <div className="product-container row my-3 gap-2">
          <div
            className="product-info col-12 px-4 col-md-5 flex-grow-1"
            style={{ height: "fit-content" }}
          >
            <div
              className="d-flex flex-column "
              style={{ height: "100%", position: "relative" }}
              dir={lang === "en" ? "ltr" : "rtl"}
            >
              {offersData.length > 0 && (
                <div className="best-offer">
                  <span className="right"></span>عروض
                  <span className="left"></span>
                </div>
              )}
              <div className="product-title-row">
                <h1 className="product-title">{product.title}</h1>
                <button
                  type="button"
                  className="product-fav-btn"
                  title={product.is_fav === "true" ? "إزالة من المفضلة" : "إضافة للمفضلة"}
                  onClick={() => addToFav(product.id)}
                >
                  <IconsGen
                    icon_name={"heartCart"}
                    active={product.is_fav === "true"}
                  />
                </button>
              </div>

              {/* Meta Badges */}
              <div className="product-meta-row">
                <span className="product-meta-badge">
                  <LuBox size={14} />
                  <span>{_("home.productcode")}:</span>
                  <strong>#{product.id}</strong>
                </span>
                {selectedVariant.sku ? (
                  <span className="product-meta-badge">
                    <LuTag size={14} />
                    <span>{_("home.productsku")}:</span>
                    <strong>{selectedVariant.sku}</strong>
                  </span>
                ) : null}
              </div>

              {/* Modern Pricing Box */}
              <div className="product-pricing-box">
                {/* Cost Price */}
                <div className="pricing-row-cost">
                  <p className="pricing-label">
                    {_("home.costprice")}
                  </p>
                  <p className="pricing-value">
                    {(userData?.level_data && userData?.level_data?.commission) || isProductOfferActive(product) ? (
                      <>
                        <del className="text-secondary fs-6 me-2">{product.price}</del>
                      </>
                    ) : (
                      product.price
                    )}
                    {" "}{currencyLabel}
                  </p>
                </div>

                {/* Expected Selling Price */}
                {product.suggested_price && Number(product.suggested_price) > 0 ? (
                  <div className="pricing-row-expected">
                    <p className="pricing-label">
                      <LuTrendingUp size={18} />
                      <span>{_("home.suggestedPrice")}</span>
                    </p>
                    <p className="pricing-value">
                      {Number(product.suggested_price).toLocaleString()} {currencyLabel}
                    </p>
                  </div>
                ) : null}

                {/* Category Offer Price */}
                {isProductOfferActive(product) && (
                  <div className="pricing-row-special flex-column">
                    <div className="d-flex justify-content-between w-100">
                      <p className="pricing-label text-danger fw-bold m-0">
                        {_("home.sellingPrice")}
                      </p>
                      <p className="pricing-value text-danger fw-bold fs-5 m-0">
                        {product.selling_price} {currencyLabel}
                      </p>
                    </div>
                    <OfferCountdownTimer offerValidUntil={product.offer_valid_until} compact={false} />
                  </div>
                )}

                {/* Level Price */}
                {userData?.level_data && userData?.level_data?.commission ? (
                  <div className="pricing-row-special ecombo-primary">
                    <p className="pricing-label fw-bold m-0">
                      {_("home.levelPrice")}
                    </p>
                    <p className="pricing-value fw-bold fs-5 m-0">
                      {(isProductOfferActive(product) && product.selling_price ? product.selling_price : product.price) - userData?.level_data?.commission}{" "}
                      {currencyLabel}
                    </p>
                  </div>
                ) : null}
              </div>

              {productVariants.length > 1 ? (
                <VariantsSelector
                  variants={productVariants}
                  selectedVariant={selectedVariant}
                  setSelectedVariant={handleSelectedVariant}
                />
              ) : null}

              {/* Product Description */}
              <div className="product-desc-box">
                <div className="product-desc-title">
                  <LuFileText size={17} style={{ color: "#59c6c9" }} />
                  <span>{_("home.productdescription") || "تفاصيل ومواصفات المنتج"}</span>
                </div>
                <div
                  style={{
                    textAlign: lang === "en" ? "left" : "right",
                  }}
                  className="product-description"
                  dangerouslySetInnerHTML={{ __html: product?.description }}
                ></div>
              </div>

              {/* offer  */}
              {offersData.length > 0 && (
                <div className="py-4 mt-3 price_bundles-content mt-3">
                  {offersData
                    ?.sort((a, b) => a.quantity - b.quantity)
                    .map((offer, index) => (
                      <div key={offer?.id} className="bundle mt-3">
                        <div
                          className="d-flex justify-content-start align-items-center"
                          role="button"
                        >
                          <input
                            className="form-check-input me-2 mx-2"
                            type="radio"
                            name="offer"
                            id={`${offer?.id}`}
                            checked={selectedOffer === `${offer?.id}`}
                            onChange={handleOfferChange}
                          />
                          <label
                            className="d-flex justify-content-between align-items-center w-100"
                            htmlFor={`${offer?.id}`}
                          >
                            <p
                              style={{ fontSize: 20 }}
                              className="dark-blue mb-0"
                            >
                              {offer?.quantity &&
                                `اشتري   ${offer?.quantity} ${
                                  offer?.quantity == 1
                                    ? "قطعة بسعر "
                                    : "قطع بسعر "
                                } `}
                            </p>
                            <div className="d-flex flex-column justify-content-start align-items-center gap-0">
                              <span
                                className="current-price gray"
                                style={{ fontSize: 20 }}
                              >
                                {offer?.price_after}
                                {currencyLabel}
                              </span>
                              <span
                                className="old-price gray"
                                style={{ fontSize: 16 }}
                              >
                                <del>
                                  {offer?.price_before}
                                  {currencyLabel}
                                </del>
                              </span>
                            </div>
                          </label>
                        </div>
                      </div>
                    ))}
                </div>
              )}

              <div className="product-actions-box">
                {["AFFILIATE", "ADMIN", "EMPLOYEE", "FULFILLMENT"].includes(
                  role.toUpperCase()
                ) ? (
                  <div className="d-flex gap-3">
                    {!selectedOffer && (
                      <button
                        className="btn btn-order-now flex-grow-1"
                        onClick={async () => {
                          if (!(await ensureProductOrderAllowed())) return;
                          Navigate(
                            `/${slug}/${lang}/order-now/${id}/${selectedVariant.id}${
                              exclusiveParam ? `?exclusive=${exclusiveParam}` : ""
                            }`
                          );
                        }}
                      >
                        <LuZap size={18} />
                        <span>{_("home.ordernow")}</span>
                      </button>
                    )}
                    <button
                      onClick={selectedOffer ? addOfferToCart : addToCart}
                      className="btn btn-add-cart flex-grow-1"
                    >
                      <LuShoppingCart size={18} />
                      <span>{_("home.addtocart")}</span>
                    </button>
                  </div>
                ) : null}

                {product.google_drive_link ? (
                  <div>
                    <Link
                      to={product.google_drive_link}
                      className="text-decoration-none"
                      target={"_blank"}
                    >
                      <button className="btn btn-drive-files">
                        <IconsGen icon_name={"googleDrive"} />
                        <span>{_("home.productfiles")}</span>
                      </button>
                    </Link>
                  </div>
                ) : null}
              </div>

              <div className="product-export-dropdown d-flex flex-column gap-2 mb-4">
                {key?.length > 0 ? (
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="success"
                      id="dropdown-basic"
                      className="w-100"
                      style={{
                        backgroundColor: "transparent",
                        color: "rgba(23, 43, 77, 1)",
                      }}
                    >
                      {_("panel.retrieveAtEasyOrders")}
                      <img
                        src={easyOrders}
                        width="20px"
                        className="mx-2"
                        alt="Easy Orders Icon"
                      />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="w-100">
                      {key.map((item, index) => (
                        <Dropdown.Item
                          key={index}
                          onClick={() => exportToEasyOrders(item.secretKey)}
                        >
                          {item.secretKey}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                ) : null}
                {/* LightFunnels dropdown  */}
                {lightFunnelsKey?.length > 0 ? (
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="success"
                      id="dropdown-basic"
                      className="w-100"
                      style={{
                        backgroundColor: "transparent",
                        color: "rgba(23, 43, 77, 1)",
                      }}
                    >
                      {_("panel.retrieveAtLightFunnels")}
                      <img
                        src={lightFunnels}
                        width="100px"
                        className="mx-2"
                        alt="LightFunnels Icon"
                      />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="w-100">
                      {lightFunnelsKey.map((item, index) => (
                        <Dropdown.Item
                          key={index}
                          onClick={() => exportToLightFunnels(item.secretKey)}
                        >
                          {item.secretKey.slice(0, 60)}...
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                ) : null}

                {/* Yalla Shop dropdown  */}
                {userData?.id === 12330 && yallaShopKey?.length > 0 ? (
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="success"
                      id="dropdown-basic"
                      className="w-100"
                      style={{
                        backgroundColor: "transparent",
                        color: "rgba(23, 43, 77, 1)",
                      }}
                    >
                      {/* Export to Yalla Shop */}
                      استيراد فى يلا شوب
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="w-100">
                      {yallaShopKey.map((item, index) => (
                        <Dropdown.Item
                          key={index}
                          onClick={() => exportToYallaShop(item.secretKey)}
                        >
                          {item.secretKey}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                ) : null}

                {/* Shopify dropdown */}
                {userData?.id === 3 && shopifyIntegrations?.length > 0 ? (
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="success"
                      id="dropdown-basic"
                      className="w-100"
                      style={{
                        backgroundColor: "transparent",
                        color: "rgba(23, 43, 77, 1)",
                      }}
                    >
                      {_("panel.retrieveAtShopify")}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 256 292"
                        className="mx-2"
                      >
                        <path
                          fill="#95BF47"
                          d="M223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357-1.055-.088-23.383-1.743-23.383-1.743s-15.507-15.395-17.209-17.099c-1.703-1.703-5.029-1.185-6.32-.805-.183.053-3.388 1.046-8.678 2.68-5.18-14.906-14.322-28.604-30.405-28.604-.444 0-.901.018-1.358.044C129.31 3.407 123.98 0 119.468 0 75.733 0 54.893 54.674 48.277 82.474c-17.244 5.346-29.448 9.129-30.958 9.611-9.653 3.027-9.953 3.327-11.217 12.23C5.035 111.463 0 249.905 0 249.905l176.203 32.47 95.275-24.479S224.072 59.251 223.774 57.34"
                        />
                        <path
                          fill="#5E8E3E"
                          d="M185.645 53.24c-1.055-.088-23.383-1.743-23.383-1.743s-15.507-15.395-17.209-17.099c-.637-.634-1.496-.95-2.394-1.069l-13.116 267.045 95.275-24.479S224.072 59.251 223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357"
                        />
                      </svg>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="w-100">
                      {shopifyIntegrations.map((integration) => (
                        <Dropdown.Item
                          key={integration.id}
                          onClick={() => exportToShopify(integration.id)}
                        >
                          {integration.shop_domain}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                ) : null}
              </div>
            </div>
          </div>

          <ProductSwipper productImgs={productImgs} />
        </div>
      </div>
      <div className="d-block d-md-none">
        <div className="product-actions-box my-4 px-2">
          {["AFFILIATE", "EMPLOYEE", "ADMIN"].includes(role.toUpperCase()) ? (
            <div className="top d-flex gap-4">
              <button
                onClick={addToCart}
                className="btn btn-add-cart"
                style={{ flexGrow: 1 }}
              >
                {_("home.addtocart")}
              </button>
            </div>
          ) : (
            ""
          )}
          <div className="bottom" style={{}}>
            <Link to={product.google_drive_link} target={"_blank"}>
              <button
                className="btn btn-drive-files"
                style={{ width: "100%" }}
              >
                {_("home.productfiles")} <IconsGen icon_name={"googleDrive"} />
              </button>
            </Link>
          </div>
        </div>
      </div>
      {sameCatProducts.length > 0 ? (
        <ProductsSlider row={sameCatProducts} altName={altName} />
      ) : (
        ""
      )}
    </Container>
  );
};

export default Product;
